import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import {
  getItemLevel,
  updateItemForecastReplenishment
} from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";
import { Link } from "react-router-dom";
import StatusModal from "../../common/StatusModal";

class ManageItemForecastReplenishmentByDC extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item && this.state.lookup.wse) {
      var item = parseInt(this.state.lookup.item, 10).toString();
      getItemLevel(item, this.state.lookup.wse).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        if (res.data.success) {
          const data = res.data.data;
          //const whsesForItem = res.data.data.whsesForItem;
         // delete data.whsesForItem;
          this.setState({ data });
          this.setState({
            header: [
              {
                label: "Item",
                // value: res.data.data.itemNumber,
                value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                name: "itemNumber"
              },
              {
                label: "Description",
                value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                value: res.data.data.lineCode,
                name: "lineCode"
              },
              {
                label: "Part",
                value: res.data.data.partNumber,
                name: "partNumber"
              },
              {
                label: "Warehouse",
                //value: whsesForItem,

                name: "wse"
              },
              {
                label: "Vendor",
                value: res.data.data.vend,
                name: "vend"
              },
              {
                label: "Vendor Name",
                value: res.data.data.vendorName,
                name: "vendorName"
              }
            ],
            cards: [
              //cards
              {
                card1: [
                  {
                    label: "Last Period Processed",
                    value: res.data.data.infLpp,
                    name: "infLpp"
                  },
                  {
                    label: "Init Deseasonalized Demand",
                    value: res.data.data.infDdi,
                    name: "infDdi"
                  },
                  {
                    label: "Deseasonalized Demand",
                    value: res.data.data.infDd,
                    name: "infDd"
                  },
                  {
                    label: "Desired Service Level",
                    value: res.data.data.infDser,
                    name: "infDser"
                  },
                  {
                    label: "Pend DSER",
                    value: res.data.data.infPendDser,
                    name: "infPendDser"
                  },
                  {
                    label: "Profile Tag",
                    value: res.data.data.infPtag,
                    name: "infPtag"
                  },
                  {
                    label: "Order Strategy",
                    value: res.data.data.infOstrat,
                    name: "infOstrat"
                  },
                  {
                    label: "Time Supply Minimum",
                    value: res.data.data.infTmin,
                    name: "infTmin"
                  },
                  {
                    label: "Ptag Year",
                    value: res.data.data.infPtagYear,
                    name: "ptagYear"
                  },
                  {
                    label: "User Minimum",
                    value: res.data.data.infUserMin,
                    name: "infUserMin"
                  },
                  {
                    label: "Fixed Order Quantity",
                    value: res.data.data.infFoq,
                    name: "infFoq"
                  },
                  {
                    label: "Forecast Type",
                    value: res.data.data.infFt,
                    name: "infFt"
                  },
                  {
                    label: "User Maximum",
                    value: res.data.data.infUserMax,
                    name: "infUserMax"
                  },
                  {
                    label: "Coordinated Item Flag",
                    value: res.data.data.infCoorflg,
                    name: "infCoorflg"
                  },
                  {
                    label: "Cstock",
                    value: res.data.data.infCstock,
                    name: "infCstock"
                  },
                  {
                    label: "Lumpy Item Flag",
                    value: res.data.data.infLumpsw,
                    name: "infLumpsw"
                  },
                  {
                    label: "Item Lead Time",
                    value: res.data.data.infLt,
                    name: "infLt"
                  }
                ]
              },
              {
                card2: [
                  {
                    label: "Demand Filter Reg",
                    value: res.data.data.infDflreg,
                    name: "infDflreg"
                  },
                  {
                    label: "Fcst Ex Reg",
                    value: res.data.data.infFcStreg,
                    name: "infFcStreg"
                  },
                  {
                    label: "Tracking Signal Reg",
                    value: res.data.data.infTsreg,
                    name: "infTsreg"
                  },
                  {
                    label: "Last Period DD",
                    value: res.data.data.infLdd,
                    name: "infLdd"
                  },
                  {
                    label: "Dying Item Reg",
                    value: res.data.data.infDireg,
                    name: "infDireg"
                  },
                  {
                    label: "Last Period DDI",
                    value: res.data.data.infLddi,
                    name: "infLddi"
                  },
                  {
                    label: "Bypass DDU Reg",
                    value: res.data.data.infBypreg,
                    name: "infBypreg"
                  },
                  {
                    label: "Last Modified",
                    value: res.data.data.infModDate,
                    name: "infModDate"
                  }
                ]
              },
              {
                card3: [
                  {
                    label: "Replenishment IC",
                    value: res.data.data.infReplenishIc,
                    name: "infReplenishIc"
                  },
                  {
                    label: "Pack Rounding 1",
                    value: res.data.data.infPackSw,
                    name: "infPackSw"
                  },
                  {
                    label: "2",
                    value: res.data.data.infPackSw2,
                    name: "infPackSw2"
                  },
                  {
                    label: "Tier Rounding 1",
                    value: res.data.data.infTierSw,
                    name: "infTierSw"
                  },
                  {
                    label: "2",
                    value: res.data.data.infTierSw2,
                    name: "infTierSw2"
                  }
                ]
              }
            ]
          });
        } else {
          this.setState({
            header: [
              {
                label: "Item",
                // value: res.data.data.itemNumber,
                value: this.state.lookup.item,
                // value: this.numberToZeroPadded(res.data.data.itemNumber, 9),
                name: "itemNumber"
              },
              {
                label: "Description",
                // value: res.data.data.description,
                name: "description"
              },
              {
                label: "Line",
                // value: res.data.data.lineCode,
                name: "lineCode"
              },
              {
                label: "Part",
                // value: res.data.data.partNumber,
                name: "partNumber"
              },
              {
                label: "Warehouse",
                // value: whsesForItem,

                name: "wse"
              },
              {
                label: "Vendor",
                // value: res.data.data.vend,
                name: "vend"
              },
              {
                label: "Vendor Name",
                // value: res.data.data.vendorName,
                name: "vendorName"
              }
            ],

            cards: [
              //cards
              {
                card1: [
                  {
                    label: "Last Period Proceessed",
                    // value: res.data.data.infLpp,
                    value: "",
                    name: "infLpp"
                  },
                  {
                    label: "Init Deseasonalized Demand",
                    // value: res.data.data.infDdi,
                    value: "",
                    name: "infDdi"
                  },
                  {
                    label: "Deseasonalized Demand",
                    // value: res.data.data.infDd,
                    value: "",
                    name: "infDd"
                  },
                  {
                    label: "Desired Service Level",
                    // value: res.data.data.infDser,
                    value: "",
                    name: "infDser"
                  },
                  {
                    label: "Pend DSER",
                    // value: res.data.data.infPendDser,
                    value: "",
                    name: "infPendDser"
                  },
                  {
                    label: "Profile Tag",
                    // value: res.data.data.infPtag,
                    value: "",
                    name: "infPtag"
                  },
                  {
                    label: "Order Strategy",
                    // value: res.data.data.infOstrat,
                    value: "",
                    name: "infOstrat"
                  },
                  {
                    label: "Time Supply Minimum",
                    // value: res.data.data.infTmin,
                    value: "",
                    name: "infTmin"
                  },
                  {
                    label: "Ptag Year",
                    value: "",
                    name: "ptagYear"
                  },
                  {
                    label: "User Minimum",
                    // value: res.data.data.infUserMin,
                    value: "",
                    name: "infUserMin"
                  },
                  {
                    label: "Fixed Order Quantity",
                    // value: res.data.data.infFoq,
                    value: "",
                    name: "infFoq"
                  },
                  {
                    label: "Forecast Type",
                    // value: res.data.data.infFt,
                    value: "",
                    name: "infFt"
                  },
                  {
                    label: "User Maximum",
                    // value: res.data.data.infUserMax,
                    value: "",
                    name: "infUserMax"
                  },
                  {
                    label: "Coordinated Item Flag",
                    // value: res.data.data.infCoorflg,
                    value: "",
                    name: "infCoorflg"
                  },
                  {
                    label: "Cstock",
                    // value: res.data.data.infCstock,
                    value: "",
                    name: "infCstock"
                  },
                  {
                    label: "Lumpy Item Flag",
                    // value: res.data.data.infLumpsw,
                    value: "",
                    name: "infLumpsw"
                  },
                  {
                    label: "Item Lead Time",
                    // value: res.data.data.infLt,
                    value: "",
                    name: "infLt"
                  }
                ]
              },
              {
                card2: [
                  {
                    label: "Demand Filter Reg",
                    // value: res.data.data.infDflreg,
                    value: "",
                    name: "infDflreg"
                  },
                  {
                    label: "Fcst Ex Reg",
                    // value: res.data.data.infFcStreg,
                    value: "",
                    name: "infFcStreg"
                  },
                  {
                    label: "Tracking Signal Reg",
                    // value: res.data.data.infTsreg,
                    value: "",
                    name: "infTsreg"
                  },
                  {
                    label: "Last Period DD",
                    // value: res.data.data.infLdd,
                    value: "",
                    name: "infLdd"
                  },
                  {
                    label: "Dying Item Reg",
                    // value: res.data.data.infDireg,
                    value: "",
                    name: "infDireg"
                  },
                  {
                    label: "Last Period DDI",
                    // value: res.data.data.infLddi,
                    value: "",
                    name: "infLddi"
                  },
                  {
                    label: "Bypass DDU Reg",
                    // value: res.data.data.infBypreg,
                    value: "",
                    name: "infBypreg"
                  },
                  {
                    label: "Last Modified",
                    // value: res.data.data.infModDate,
                    value: "",
                    name: "infModDate"
                  }
                ]
              },
              {
                card3: [
                  {
                    label: "Replenishment IC",
                    // value: res.data.data.infReplenishIc,
                    value: "",
                    name: "infReplenishIc"
                  },
                  {
                    label: "Pack Rounding 1",
                    // value: res.data.data.infPackSw,
                    value: "",
                    name: "infPackSw"
                  },
                  {
                    label: "2",
                    // value: res.data.data.infPackSw2,
                    value: "",
                    name: "infPackSw2"
                  },
                  {
                    label: "Tier Rounding 1",
                    // value: res.data.data.infModDate,
                    value: "",
                    name: "infTierSw"
                  },
                  {
                    label: "2",
                    // value: res.data.data.infModDate,
                    value: "",
                    name: "infTierSw2"
                  }
                ]
              }
            ]
          });
          this.setErrorMessage(res.data.messages[0].text);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please select an item number and a warehouse");
    }
  };
  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.itemNumber,
        wse: value.header.wse ? value.header.wse[0] : 0,
        whses: value.header.wse
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      this.newInfo.itemNumber = parseInt(this.newInfo.itemNumber, 10);
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    const newData = this.newInfo;
    const prevData = this.state.data;
    delete prevData.itemNumber;
    delete newData.itemNumber;
    this.setState({
      isSaveEnabled:
        JSON.stringify(prevData).replace(/"/g, "") !==
        JSON.stringify(newData).replace(/"/g, "")
    });
  };
  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };
  save = () => {
    const formattedWhses = this.state.lookup.whses.map(wse => {
      return wse.toString();
    });
    this.setTransitioMessage(<Spinner msg="Saving..." />);

    var uId = sessionStorage.getItem("uId");
    this.newInfo.itemNumber = this.state.lookup.item;
    var obj = {
      audit: {
        userId: uId
      },
      whses: formattedWhses,
      data: this.newInfo
    };
    updateItemForecastReplenishment(obj).then(res => {
      if (res.data.success) {
        this.setState({ data: "" });
        this.newInfo = "";
        this.lookup("Item was successfully updated");
        this.setSuccessMessage("Item was successfully updated");
        this.setState({ isSaveEnabled: false });
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };
  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  handleOpenModal = () => {
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };

  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Item Forecast Replenishment By DC
        </h3>

        {/* <input onClick={e => this.lookup()} type="submit" value={"populate"} /> */}
        <HeaderLayout
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          headerData={this.state.header}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
        />

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={false}
              onClick={e => this.checkHotChangesAndClose()}
            >
              Close
            </Button>

            <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
      </div>
    );
  }
}
export default ManageItemForecastReplenishmentByDC;
